module.exports = __webpack_public_path__ + "img/tshaped.f56f4106.png";